"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'reports/v1/settings';

var SettingsAPI =
/*#__PURE__*/
function () {
  function SettingsAPI() {
    (0, _classCallCheck2.default)(this, SettingsAPI);
  }

  (0, _createClass2.default)(SettingsAPI, null, [{
    key: "get",
    value: function get() {
      return _apiClient.default.get(API_BASE);
    }
  }, {
    key: "put",
    value: function put(settings) {
      return _apiClient.default.put(API_BASE, {
        data: (0, _extends2.default)({}, settings)
      });
    }
  }, {
    key: "getIP",
    value: function getIP() {
      return _apiClient.default.get(API_BASE + "/ip-lookup");
    }
  }]);
  return SettingsAPI;
}();

exports.default = SettingsAPI;
module.exports = exports.default;